import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

type Props = {
  pdfRecrearteCount: string;
  quantity: string;
};

const PrintingAndPdfInformation = ({ pdfRecrearteCount, quantity }: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        JOB INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            PDF Recreate Count :
          </Typography>
          <Typography className="value">{pdfRecrearteCount}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            Print Quantity :
          </Typography>
          <Typography className="value">{quantity}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default PrintingAndPdfInformation;
